import React from 'react';
import { Download } from 'lucide-react';

interface DownloadButtonProps {
  content: string;
  filename: string;
  className?: string;
  iconClassName?: string;
}

export function DownloadButton({ 
  content, 
  filename,
  className = '',
  iconClassName = 'h-4 w-4'
}: DownloadButtonProps) {
  const downloadFile = () => {
    try {
      let url;
      if (content.startsWith('data:')) {
        // If content is a data URL, use it directly
        url = content;
      } else {
        // Otherwise create a blob
        const blob = new Blob([content], { type: 'text/plain' });
        url = URL.createObjectURL(blob);
      }
      const link = document.createElement('a');
      link.style.display = 'none';
      link.href = url;
      link.download = filename;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      if (!content.startsWith('data:')) {
        URL.revokeObjectURL(url);
      }
    } catch (error) {
      console.error('Download failed:', error);
    }
  };

  return (
    <button
      onClick={downloadFile}
      className={`p-2 text-gray-500 hover:text-gray-700 hover:bg-gray-100 rounded-md ${className}`}
      title="Download file"
    >
      <Download className={iconClassName} />
    </button>
  );
}
